import React, { useState } from 'react';

import { BaseModalContainer, CrossIcon, Loader } from '@nw/shared/ui';

import { JusPayPaymentCancelConfirmationModal } from './JusPayPaymentCancelConfirmationModal';
import {
  closeIconWrapperStyles,
  Iframe,
  IframeContainer
} from './styledComponents';

import './styles.scss';

interface JusPayPaymentPopUpModalProps {
  paymentLink: string;
  onJusPayModalClose: () => void;
  showJusPayPaymentModal: boolean;
}

const JusPayPaymentPopUpModal: React.FC<JusPayPaymentPopUpModalProps> = ({
  paymentLink,
  onJusPayModalClose,
  showJusPayPaymentModal
}) => {
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const onModalClose = (): void => {
    setIsConfirmationModalOpen(true);
  };

  const onCloseConfirmationModal = (shouldClose: boolean): void => {
    setIsConfirmationModalOpen(false);
    if (shouldClose) {
      onJusPayModalClose();
    }
  };

  return (
    <>
      <BaseModalContainer
        isModalOpen={showJusPayPaymentModal}
        baseModalContainerStyles={'jusPayBaseModalContainerStyles'}
        closeIconWrapperStyles={closeIconWrapperStyles}
        onModalClose={onModalClose}
        crossIcon={CrossIcon}
      >
        <IframeContainer>
          <Iframe src={paymentLink} allow="payment *;" />
        </IframeContainer>
      </BaseModalContainer>

      <JusPayPaymentCancelConfirmationModal
        isModalOpen={isConfirmationModalOpen}
        onCloseConfirmationModal={onCloseConfirmationModal}
      />
    </>
  );
};

export default JusPayPaymentPopUpModal;
